<template>
  <el-form
    ref="phoneLoginForm"
    :model="form.field"
    status-icon
    :validate-on-rule-change="false"
    :show-message="false"
  >
    <el-row>
      <el-col :span="6">
        <el-form-item
          required
          prop="phoneArea"
          :error="form.errors.phoneArea"
          :rules="[
        {required: true,message:$t('cmsg.required')},
        {type: 'number',message:$t('cmsg.integerRequired')}
        ]"
        >
          <el-select
            v-model="form.field.phoneArea"
            v-model.number="form.field.phoneArea"
            filterable
            :placeholder="$t('cmsg.countryCode')"
          >
            <el-option v-for="i in $countryCodes" :label="i.label" :value="i.value" :key="i.label"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="18">
        <el-form-item
          required
          prop="username"
          :error="form.errors.username"
          :rules="[
        {required: true,message:$t('cmsg.required')},
        {type: 'number',message:$t('cmsg.integerRequired')}
        ]"
        >
          <el-input
            v-model="form.field.username"
            autofocus
            v-model.number="form.field.username"
            :placeholder="$t('cmsg.mobile')"
            @keyup.enter.native="onSubmit"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item required prop="password" :error="form.errors.password"
      :rules="[
        {required: true,message:$t('cmsg.required')},
        {max: 128,message:$t('cmsg.required')}
        ]">
      <el-input
        v-model="form.field.password"
        type="password"
        max="128"
        :placeholder="$t('cmsg.password')"
        @keyup.enter.native="onSubmit"
      ></el-input>
    </el-form-item>
    <loginMenu :form-obj.sync="form.field" />
    <!-- <p class="bg-danger" v-if="form.err">{{form.err}}</p> -->
    <el-form-item>
      <el-button
        type="primary"
        @click="onSubmit"
        class="submit_btn"
        :loading="form.loading"
      >{{$t('cmsg.loginBtn')}}</el-button>
    </el-form-item>
    <regBtn />
  </el-form>
</template>

<script>
import Cookies from "js-cookie";
import loginMenu from "./loginMenu.vue";
import regBtn from "./regBtn.vue";
export default {
  name: "phone-login",
  components: {
    loginMenu,
    regBtn
  },
  data() {
    return {
      form: {
        field: {
          loginType: "dentalCloudSite",
          username: null,
          password: "",
          rPwd: false,
          phoneArea: null
        },
        loading: false,
        errors: {
          phoneArea: null,
          username: null,
          password: null
        },
        err: ""
      }
    };
  },
  methods: {
    getRPwd() {
      var u = {};
      u["un"] = Cookies.get("un");
      u["upa"] = Cookies.get("upa");
      // u["ult"] = Cookies.get("ult");
      var t = this;
      t.$axios
        .post("/api/fetchRPwd", u, {
          json: true,
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          console.log(res.data);
          if (
            res.data &&
            res.data.status === "success" &&
            res.data.result !== ""
          ) {
            t.form.field.password = res.data.result;
            console.log("t.form.field: ",t.form.field)
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    onSubmit() {
      this.form.err = "";
      // var vueObj = this;
      this.form.field.username = parseInt(this.form.field.username);
      this.form.field.phoneArea = parseInt(this.form.field.phoneArea);
      this.$refs["phoneLoginForm"].validate(valid => {
        if (valid) {
          // console.log(this.form.field);
            // return false;
          this.form.loading = true;
          this.form.field.username = this.form.field.username.toString();
          this.form.field.phoneArea = this.form.field.phoneArea.toString();
          this.$axios
            .post(`/api/login`, this.form.field, {
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            })
            .then(res => {
              // console.log("res: ", res.data);
              if (res.data && res.data.status === "success") {
                Cookies.set("token", res.data.result.token);
                Cookies.set("country", res.data.result.country);
                Cookies.set("user_id", res.data.result.user_id);
                Cookies.set("uTitle", res.data.result.nick_name);
                Cookies.set("factories", res.data.result.factories);
                Cookies.set("factory_names", res.data.result.factory_names);
                Cookies.set("admin_factories", res.data.result.admin_factories);
                // Cookies.set("perms", res.data.result.perms.join(","));
                // window.location = this.$router.resolve({name:"cases"}).href;
                this.$redirect({ name: "cases" });
              } else {
                this.form.field.username = parseInt(this.form.field.username);
                this.form.field.phoneArea = parseInt(this.form.field.phoneArea);
                console.log(res.data.result);
                var ermsg = {};
                var fs = [];
                try {
                  ermsg = JSON.parse(res.data.result);
                } catch (e) {
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.form.errors[erk] = this.$t("cmsg.errField");
                  fs.push(erk);
                });
                this.form.err = res.data.result;
                this.$message({
                  type: "error",
                  duration:0,
                  showClose:true,
                  message: fs.join(",")+this.$t("cmsg.errField")
                });
                console.log(this.form.errors);
              }
              this.form.loading = false;
            })
            .catch(err => {
              console.log("err: ", err);
              this.form.err = this.$t("cmsg.mting");
              this.form.loading = false;
            });
        } else {
          this.form.loading = false;
          return false;
        }
      });
    }
  },
  watch: {
    "form.field.username": function(v) {
      console.log(v);
      var remberPwd = Cookies.get("remberPwd");
      var un = Cookies.get("un");
      if(remberPwd && un && un !== v) {
        this.form.field.rPwd = false;
        this.$EventBus.$emit("ndpwd", false);
      }
      console.log(this.form.field);
    }
  },
  mounted() {
    var tLang = Cookies.get("lang");
    if (tLang === "cn" || !tLang) {
      this.form.field.phoneArea = 86;
    }
    // var ult = Cookies.get("ult");
    // if (ult) {
      // this.form.field.loginType = ult;
    // } else {
      this.form.field.loginType = pub.loginSdk;
    // }
    var cActiveTab = Cookies.get("activeTab");
      var remberPwd = Cookies.get("remberPwd");
    if (cActiveTab && cActiveTab === "mobileLogin") {
      var un = Cookies.get("un");
      if (remberPwd && un && un.indexOf("@") < 0) {
        this.form.field.username = parseInt(un);
        this.form.field.rPwd = true;
      var upa = Cookies.get("upa");
        if(upa) {
          this.form.field.phoneArea = parseInt(upa);
        }
      }
    }
    // this.$EventBus.$on("dpwd",(v)=>{
    //   console.log("dpwd: ", v);
    //   this.form.field.password = v;
    // });
    if (remberPwd) {
      this.getRPwd();
    }
  }
};
</script>
<style>
.el-form-item {
  text-align: left;
}
.el-col {
  text-align: left;
}
.el-col .el-form-item {
  width: 100%;
}
.el-col .el-form-item .el-select {
  width: 100%;
}
.el-form-item:not(:nth-last-of-type(1)) {
  margin-bottom: 0px;
}
.el-form-item:first-of-type {
  margin-bottom: 20px;
}
.submit_btn {
  width: 100%;
}
@media only screen and (max-width: 1020px) {
  .submit_btn {
    width: 100%;
  }
}
</style>
